import axios from "axios";
import { API_URL } from "../utils/Constant";

/**
 * Generate invoice data
 * @param {object} params - The payload for the API request
 * @returns {object} The response from the API
 */
export const generateInvoiceData = async (params) => {
  try {
    const response = await axios.get(
      `${API_URL}/invoicing_data/`, { params },
    );
    const data = response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.detail || "Something went wrong." };
  }
};

/**
 * Update invoice data
 * @param {object} payload - The payload for the API request
 * @returns {object} The response from the API
 */
export const updateInvoiceData = async (payload) => {
  try {
    const response = await axios.patch(`${API_URL}/update_qbo_items/`, payload);
    const data = response.data;
    return { success: true, ...data, message: data.message || "Invoice data updated successfully" };
  } catch (e) {
    const message = e?.response?.data?.message ?? "Failed to update invoice data";
    return {
      success: false,
      message,
      status_code: e?.response?.status ?? 400,
      error_message: e?.message ?? "Fail",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

/**
 * Get invoice history
 * @param {object} params - The payload for the API request (date_range optional)
 * @returns {object} The response from the API
 */
export const getInvoiceHistory = async (params = {}, signal = null) => {
  try {
    const response = await axios.get(
      `${API_URL}/invoice_history/`, { params, signal },
    );
    const data = response.data;
    return { success: true, data };
  } catch (e) {
    return {
      success: false, message: e.response?.data?.detail || e.response?.data?.message || "Something went wrong.", data: [], canceled: e.code === "ERR_CANCELED",
    };
  }
};
